import { AnimatePresence, motion } from 'framer-motion';

import type { FC, ReactNode } from 'react';
import { usePathname } from '../../lib/use-pathname';

const FadePageWrapper: FC<{
  children: ReactNode;
  durationInSec?: number;
}> = ({ children, durationInSec = 0.5 }) => {
  const pathname = usePathname();

  return (
    <AnimatePresence initial={false} mode="wait">
      <motion.div
        animate={{ opacity: 1 }}
        className="relative min-w-0"
        exit={{ opacity: 0, transition: { duration: 0.3 } }}
        initial={{ opacity: 0 }}
        key={pathname}
        style={{ isolation: 'isolate' }}
        transition={{ duration: durationInSec }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default FadePageWrapper;
